import React, { useState } from 'react';
import { buildImageSources } from '../../utils/thumbnails';

export default function SmartImage({ movie, type = 'portrait', alt, className, style, eager }) {
  const sources = buildImageSources(movie, type);
  const [idx, setIdx]       = useState(0);
  const [failed, setFailed] = useState(false);

  if (failed || sources.length === 0) {
    return (
      <div className="movie-thumb-placeholder" style={style}>
        <span className="thumb-icon">🎬</span>
        <span className="thumb-genre">{movie?.genres || movie?.genre || ''}</span>
      </div>
    );
  }

  return (
    <img
      src={sources[idx]}
      alt={alt || movie?.title || ''}
      className={className}
      style={style}
      loading={eager ? 'eager' : 'lazy'}
      fetchpriority={eager ? 'high' : 'auto'}
      decoding="async"
      onError={() => {
        if (idx < sources.length - 1) setIdx(i => i + 1);
        else setFailed(true);
      }}
    />
  );
}

// Episode SmartImage — uses buildEpisodeSources with parent filmid
export function EpisodeImage({ episode, parentFilmId, className, style }) {
  const { buildEpisodeSources } = require('../../utils/thumbnails');
  const sources = buildEpisodeSources(episode, parentFilmId);
  const [idx, setIdx]       = useState(0);
  const [failed, setFailed] = useState(false);

  if (failed || sources.length === 0) {
    return (
      <div className="ep-thumb-placeholder" style={style}>
        <span>▶</span>
      </div>
    );
  }

  return (
    <img
      src={sources[idx]}
      alt={episode?.title || ''}
      className={className}
      style={style}
      loading="lazy"
      onError={() => {
        if (idx < sources.length - 1) setIdx(i => i + 1);
        else setFailed(true);
      }}
    />
  );
}
